export const A_CALCULATE_TOUR = "A_CALCULATE_TOUR";
export const A_BUY_TOUR = "A_BUY_TOUR";
export const A_BUY_TOUR_NO_REGISTRATION = "A_BUY_TOUR_NO_REGISTRATION";
export const A_SET_TOUR = "A_SET_TOUR";
export const A_GET_MANAGERS = "A_GET_MANAGERS";
export const A_GET_BRANCHES = "A_GET_BRANCHES";
export const A_GET_TOURIST_DATA = "A_GET_TOURIST_DATA";
export const A_ADDITIONAL_HOTEL_SERVICES = "A_ADDITIONAL_HOTEL_SERVICES";
export const A_SET_TOUR_INFO = "A_SET_TOUR_INFO";
export const A_GET_GDS_FLIGHT = "A_GET_GDS_FLIGHT";
export const A_GET_FLIGHTS_SEQUENCIES = "A_GET_FLIGHTS_SEQUENCIES";
export const A_GET_TARIFF = "A_GET_TARIFF";
export const A_REBUILD_FLIGHT = "A_REBUILD_FLIGHT";
export const A_SET_API_URL = "A_SET_API_URL";
export const A_SET_API_ORIGIN = "A_SET_API_ORIGIN";
export const A_ADDITIONAL_FLIGHT_SERVICES = "A_ADDITIONAL_FLIGHT_SERVICES";
export const A_CALCULATE_INDIVIDUAL_SERVICE_COST = "A_CALCULATE_INDIVIDUAL_SERVICE_COST";
export const A_GET_USER_ALL_INFO = "A_GET_USER_ALL_INFO";
export const A_GET_HOTELS_FOR_MAP = "A_GET_HOTELS_FOR_MAP";
export const A_CHECK_DOUBLE_DOGOVOR = "A_CHECK_DOUBLE_DOGOVOR";
export const A_GET_PROMOCODES = "A_GET_PROMOCODES";
export const A_CHECK_PROMOCODE = "A_CHECK_PROMOCODE";
export const A_CHECK_DISCOUNT = "A_CHECK_DISCOUNT";
